declare global {
  interface Window {
    pintrk: any
  }
}

// Injects the official Pinterest Tag base code into the document <head>
// and fires the initial page event. Inserts the values exactly as provided.
export function initPinterestTag() {
  if (typeof window === 'undefined') return
  if (window.pintrk) return

  !(function (e: string) {
    if (!window.pintrk) {
      window.pintrk = function () {
        window.pintrk.queue.push(Array.prototype.slice.call(arguments))
      }
      const n = window.pintrk
      n.queue = []
      n.version = '3.0'
      const t = document.createElement('script')
      t.async = true
      t.src = e
      const r = document.getElementsByTagName('script')[0]
      if (r && r.parentNode) {
        r.parentNode.insertBefore(t, r)
      } else {
        // Fallback for environments without an existing <script> tag in the DOM
        ;(document.head || document.documentElement).appendChild(t)
      }
    }
  })('https://s.pinimg.com/ct/core.js')

  window.pintrk('load', '2613895730757', { em: 'INSERT_USER_EMAIL' })
  window.pintrk('page')
}
